export function initSectionEarningPoints() {
  const container = document.getElementById("ep-accordion");
  const spinner = document.getElementById("ep-loading-spinner");
  const searchInput = document.getElementById("ep-search-input");
  const dropdownBtn = document.getElementById("ep-category-dropdown-btn");
  const dropdownLabel = document.getElementById("ep-category-dropdown-label");
  const dropdownArrow = document.getElementById("ep-category-dropdown-arrow");
  const dropdownMenu = document.getElementById("ep-category-dropdown-menu");
  const chipContainer = document.getElementById("ep-chip-container");
  const chipsWrapper = document.getElementById("ep-chips-wrapper");
  const clearAllBtn = document.getElementById("ep-clear-all-filters");

  if (!container) return;

  const STYLESHEET_URI = container.dataset.stylesheetUri;

  let allDocs = [];
  let activeSearch = "";
  let activeCategory = "";
  let debounceTimer = null;

  function showSpinner() {
    spinner.classList.remove("hidden");
    container.classList.add("hidden");
  }

  function hideSpinner() {
    spinner.classList.add("hidden");
    container.classList.remove("hidden");
  }

  function buildTypesenseUrl(query, categorySlug) {
    const params = {
      q: query || "*",
      query_by: "title,searchable_text",
      sort_by: "title:asc",
      per_page: 50,
      page: 1,
      num_typos: 0,
      prefix: false,
      drop_tokens_threshold: 0,
    };

    if (categorySlug) {
      params.filter_by = `categories:=[${categorySlug}]`;
    }

    if (!query || query === "*") {
      params.infix = "off";
    }

    return (
      `${envConfig.TYPESENSE_BASE_URL}:${envConfig.TYPESENSE_PORT}/collections/how_to_earn_points/documents/search?` +
      new URLSearchParams(params)
    );
  }

  // Initial load
  async function init() {
    showSpinner();

    try {
      const res = await fetch(buildTypesenseUrl("*", ""), {
        headers: { "X-TYPESENSE-API-KEY": envConfig.TYPESENSE_SEARCH_ONLY_KEY },
      });

      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const data = await res.json();
      allDocs = data.hits?.map((hit) => hit.document) || [];

      const categoryMap = {};
      allDocs.forEach((doc) => {
        const slugs = Array.isArray(doc.categories) ? doc.categories : [];
        const names = Array.isArray(doc.category_names)
          ? doc.category_names
          : [];
        slugs.forEach((slug, i) => {
          if (slug && !categoryMap[slug]) {
            categoryMap[slug] = names[i] || slug;
          }
        });
      });

      const allOption = document.createElement("li");
      allOption.innerHTML = `
        <button class="ep-category-filter-btn w-full text-left p-4 hover:bg-brand-warm-gray/20 text-brand-black text-[1.15rem] transition-colors font-neutraface"
          data-slug="" data-name="All Categories">All Categories</button>`;
      dropdownMenu.appendChild(allOption);

      Object.entries(categoryMap).forEach(([slug, name]) => {
        const li = document.createElement("li");
        li.innerHTML = `
          <button class="ep-category-filter-btn w-full text-left p-4 hover:bg-brand-warm-gray/20 text-brand-black text-[1.15rem] transition-colors font-neutraface"
            data-slug="${escHtml(slug)}" data-name="${escHtml(name)}">${escHtml(name)}</button>`;
        dropdownMenu.appendChild(li);
      });

      renderAccordion(allDocs);
    } catch (err) {
      console.error("how_to_earn_points — initial load failed:", err);
      hideSpinner();
      container.classList.remove("hidden");
      container.innerHTML =
        '<p class="text-center py-12 text-red-600">Could not load data.</p>';
    }
  }

  // Typesense search
  async function performSearch() {
    const query = searchInput.value.trim();
    activeSearch = query;

    showSpinner();

    try {
      const res = await fetch(buildTypesenseUrl(query, activeCategory), {
        headers: { "X-TYPESENSE-API-KEY": envConfig.TYPESENSE_SEARCH_ONLY_KEY },
      });

      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const data = await res.json();
      const results = data.hits?.map((hit) => hit.document) || [];

      renderAccordion(results);
    } catch (err) {
      console.error("how_to_earn_points — search failed:", err);
      hideSpinner();
      container.classList.remove("hidden");
      container.innerHTML =
        '<p class="text-center py-12 text-red-600">Search failed. Please try again.</p>';
    }
  }

  function debouncedSearch() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(performSearch, 500);
  }

  // Dropdown toggle
  dropdownBtn.addEventListener("click", () => {
    dropdownMenu.classList.toggle("hidden");
    dropdownArrow.classList.toggle("rotate-180");
  });

  document.addEventListener("click", (e) => {
    if (
      !document
        .getElementById("ep-category-dropdown-container")
        .contains(e.target)
    ) {
      dropdownMenu.classList.add("hidden");
      dropdownArrow.classList.remove("rotate-180");
    }
  });

  // Category filter click
  dropdownMenu.addEventListener("click", (e) => {
    const btn = e.target.closest(".ep-category-filter-btn");
    if (!btn) return;

    activeCategory = btn.dataset.slug;
    const name = btn.dataset.name;

    dropdownLabel.textContent =
      name === "All Categories" ? "Filter by Category" : name;
    dropdownMenu.classList.add("hidden");
    dropdownArrow.classList.remove("rotate-180");

    updateChips();
    performSearch();
  });

  // Search input
  searchInput.addEventListener("input", () => {
    updateChips();
    debouncedSearch();
  });

  // Clear all
  clearAllBtn.addEventListener("click", (e) => {
    e.preventDefault();
    activeSearch = "";
    activeCategory = "";
    searchInput.value = "";
    dropdownLabel.textContent = "Filter by Category";
    updateChips();
    performSearch();
  });

  // Chips
  function updateChips() {
    chipsWrapper.innerHTML = "";
    const query = searchInput.value.trim();
    const hasSearch = query !== "";
    const hasCategory = activeCategory !== "";

    if (hasSearch) {
      chipsWrapper.appendChild(
        makeChip(query, () => {
          searchInput.value = "";
          activeSearch = "";
          updateChips();
          performSearch();
        }),
      );
    }

    if (hasCategory) {
      chipsWrapper.appendChild(
        makeChip(dropdownLabel.textContent, () => {
          activeCategory = "";
          dropdownLabel.textContent = "Filter by Category";
          updateChips();
          performSearch();
        }),
      );
    }

    chipContainer.classList.toggle("hidden", !hasSearch && !hasCategory);
  }

  function makeChip(label, onRemove) {
    const span = document.createElement("span");
    span.className =
      "w-auto flex items-center justify-between gap-[.625rem] p-2 !pl-[.625rem] md:!pl-[1.25rem] text-white text-p1 font-normal font-neutraface rounded-full bg-brand-dark-red";
    span.innerHTML = `
      <span class="capitalize">${escHtml(label)}</span>
      <img src="${STYLESHEET_URI}/resources/images/red-close-btn-with-white-bg.svg"
        alt="close" class="w-[1.5625rem] h-[1.5625rem] object-contain object-center cursor-pointer">`;
    span.querySelector("img").addEventListener("click", onRemove);
    return span;
  }

  // Render accordion
  function renderAccordion(docs) {
    container.innerHTML = "";

    if (!docs.length) {
      container.innerHTML =
        '<p class="w-full text-center text-brand-black">No results found.</p>';
      hideSpinner();
      return;
    }

    docs.forEach((doc) => {
      const title = doc.title || "";
      const description = doc.description || "";
      const featuredImg = doc.featured_image || "";
      const accordion = Array.isArray(doc.accordion) ? doc.accordion : [];
      const hasContent = accordion.length > 0;

      const rows = accordion
        .map((item) => {
          const itemTitle = item.title || "";
          const code = item.code || "";
          const points = item.points || "";
          const maxUse = item.max_use || "";
          const hasMeta = code || points || maxUse;

          return `
          <div class="w-full flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 md:gap-8 lg:gap-10 xl:gap-12 py-4 lg:py-6 border-b border-brand-warm-gray">
            <div class="flex items-center justify-start">
              <p class="w-full max-w-[55.26rem] text-[1.5625rem] leading-[2.0625rem] font-normal text-brand-black">
                ${escHtml(itemTitle)}
              </p>
            </div>
            ${
              hasMeta
                ? `
            <div class="w-max lg:w-[15.625rem] flex flex-col items-start gap-2">
              ${
                code
                  ? `
              <div class="w-max flex items-center justify-start gap-4 md:gap-6 flex-shrink-0">
                <img src="${STYLESHEET_URI}/resources/images/hashtag.svg" alt="Code" class="w-7 h-7 object-contain object-center">
                <p class="text-p1 text-brand-dark-blue font-normal">${escHtml(code)}</p>
              </div>`
                  : ""
              }
              ${
                points
                  ? `
              <div class="w-max flex items-center justify-start gap-4 md:gap-6 flex-shrink-0">
                <img src="${STYLESHEET_URI}/resources/images/star.svg" alt="Points" class="w-7 h-7 object-contain object-center">
                <p class="text-p1 text-brand-dark-blue font-normal">${escHtml(points)}</p>
              </div>`
                  : ""
              }
              ${
                maxUse
                  ? `
              <div class="w-max flex items-center justify-start gap-4 md:gap-6 flex-shrink-0">
                <img src="${STYLESHEET_URI}/resources/images/max-use.svg" alt="Max Use" class="w-7 h-7 object-contain object-center">
                <p class="text-p1 text-brand-dark-blue font-normal">${escHtml(maxUse)}</p>
              </div>`
                  : ""
              }
            </div>`
                : ""
            }
          </div>`;
        })
        .join("");

      const html = `
        <div x-data="{ open: false }" class="w-full ${hasContent ? "transition-transform duration-300 ease-in-out hover:scale-[1.01]" : ""}">
          <div
            ${
              hasContent
                ? `@click="
              open = !open;
              if (!open) return;
              $nextTick(() => {
                const offset = window.innerWidth >= 1024 ? 60 : 40;
                const top = $el.closest('[x-data]').getBoundingClientRect().top + window.scrollY - offset;
                window.scrollTo({ top: top, behavior: 'smooth' });
              })"`
                : ""
            }
            :class="open ? 'border-b-[.5rem] border-brand-warm-beige' : ''"
            class="w-full grid grid-cols-1  h-auto min-h-[9rem] ${featuredImg ? "md:grid-cols-[11.4rem_auto]" : ""} ${hasContent ? "cursor-pointer" : ""} select-none">
            ${
              featuredImg
                ? `
            <div class="w-full relative !h-[17rem] sm:!h-[19rem] md:!h-full bg-brand-light-blue">
              <img src="${escHtml(featuredImg)}" alt="${escHtml(title)}"
                class="md:absolute w-full !h-full object-contain md:object-cover object-center">
            </div>`
                : ""
            }
            <div :class="open ? 'bg-brand-dark-red border-brand-dark-red' : 'bg-brand-white-smoke border-brand-warm-gray'"
              class="w-full flex items-center justify-between gap-6 lg:gap-8 p-5 lg:pl-9 lg:py-6 lg:pr-6 transition-colors duration-200">
              <div class="w-full flex flex-col items-start ${hasContent ? "" : "max-md:items-center"} justify-between gap-2">
                <h3 :class="open ? 'text-white' : 'text-brand-dark-blue'"
                  class="w-full font-semibold text-[1.5625rem] leading-[2.0625rem] transition-colors duration-200 text-start ${hasContent ? "" : "max-md:text-center"}">
                  ${escHtml(title)}
                </h3>
                <div :class="open ? 'text-white' : 'text-brand-black'" class="w-full htmlBlock ${hasContent ? "" : "htmlBlock-para-style"}">
                  ${description}
                </div>
              </div>
              ${
                hasContent
                  ? `
              <svg x-show="!open" xmlns="http://www.w3.org/2000/svg" class="w-7 h-7 flex-shrink-0 text-brand-black"
                fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
              </svg>
              <svg x-show="open" xmlns="http://www.w3.org/2000/svg" class="w-7 h-7 flex-shrink-0 text-white"
                fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
              </svg>`
                  : ""
              }
            </div>
          </div>
          ${
            hasContent
              ? `
          <div x-show="open"
            x-transition:enter="transition ease-out duration-300"
            x-transition:enter-start="opacity-0 -translate-y-2"
            x-transition:enter-end="opacity-100 translate-y-0"
            x-transition:leave="transition ease-in duration-200"
            x-transition:leave-start="opacity-100 translate-y-0"
            x-transition:leave-end="opacity-0 -translate-y-2"
            class="overflow-hidden border border-brand-warm-gray !border-t-0">
            <div class="w-full px-5 lg:px-10 xl:px-12 flex flex-col items-center md:items-start">
              ${rows}
            </div>
          </div>`
              : ""
          }
        </div>`;

      container.insertAdjacentHTML("beforeend", html);
    });

    if (window.Alpine) {
      Alpine.initTree(container);
    }

    hideSpinner();
  }

  // XSS-safe text helper
  function escHtml(str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  init();
}

document.addEventListener("DOMContentLoaded", () => {
  initSectionEarningPoints();
});
